import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVoice3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVoice3"><Path d="M22.25 12C19.75 9.9 19.6873 4.65 17.6373 4.65C15.5873 4.65 15.5873 9.9 13.0248 9.9C10.4623 9.9 10.4623 1.5 7.89976 1.5C5.33726 1.5 4.49023 9.43902 1.75 12C4.49023 14.561 5.33726 22.5 7.89976 22.5C10.4623 22.5 10.4623 14.1 13.0248 14.1C15.5873 14.1 15.5873 19.35 17.6373 19.35C19.6873 19.35 19.75 14.0488 22.25 12Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVoice3;
